// extracted by mini-css-extract-plugin
export default {"chatButton":"ChatButton_chatButton--Tsp","chatIcon":"ChatButton_chatIcon--cxK"};